var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Box } from "../box";
import { mapBreakpointValueProp } from "../utils/breakpointProps";
import { getCosmosDataProps } from "../utils/comsosCompat";
import { defaultGetGutterValue as getGutterValue, StackLayoutContext, } from "./stack-layout-context";
export var StackLayout = React.forwardRef(function (_a, ref) {
    var _b = _a.gutter, gutter = _b === void 0 ? 3 : _b, children = _a.children, rootProps = __rest(_a, ["gutter", "children"]);
    var context = React.useMemo(function () { return ({
        gutter: gutter,
        getGutterValue: getGutterValue,
    }); }, [gutter, getGutterValue]);
    return (React.createElement(StackLayoutContext.Provider, { value: context },
        React.createElement(Box, __assign({}, { ref: ref }, { display: "flex", alignItems: "center", justifyContent: "flex-start", flexWrap: "wrap", margin: mapBreakpointValueProp(gutter, function (key) { return -getGutterValue(key); }) }, rootProps, getCosmosDataProps("stack-layout")), children)));
});
